module.exports = __webpack_public_path__ + "media/theme/banner-2cdd2d20.png";